import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { useState } from "react"

import DialogProvider from "@components/dialog_provider"
import { useCouponsPageContext } from "@contexts/main/coupons_page_context"
import { deleteCoupons } from "@domain/coupons"
import useControlledForm from "@hooks/use_controlled_form"
import { useQueryClient } from "@tanstack/react-query"
import { showErrorToast } from "@utils/toast"

export default function DeleteCoupon({
  selectedRowIds
}: {
  selectedRowIds: string[]
}) {
  const {
    translate,
    setCouponsData,
    isOpenDeleteCoupons,
    toggleDeleteCoupons
  } = useCouponsPageContext()
  const [loading, setLoading] = useState(false)
  const queryClient = useQueryClient()

  const {
    formState: { isValid }
  } = useControlledForm({
    mode: "all"
  })

  function handleClose() {
    if (loading) {
      return
    }
    toggleDeleteCoupons?.()
  }
  async function handleDelete(selectedRowId: string) {
    if (selectedRowId) {
      const {
        isSuccess,
        errorMessage,
        data: responseData
      } = await deleteCoupons({ _id: selectedRowId })
      if (!isSuccess || !responseData) {
        setLoading(false)
        showErrorToast(String(errorMessage))
        return
      }

      const response = responseData.data
      if (!response?._id) {
        return
      }

      setCouponsData?.((prevUsersData) =>
        prevUsersData.filter((item) => item._id !== selectedRowId)
      )
    }
  }

  async function onSubmit() {
    setLoading(true)

    for (const id of selectedRowIds) {
      await handleDelete(id)
    }
    queryClient.invalidateQueries({ queryKey: ["coupons-data-table"] })
    setLoading(false)
    handleClose()
  }

  return (
    <DialogProvider
      title={translate("delete_user")}
      leftButton={{
        text: translate("cancel"),
        color: "secondary",
        onClick: handleClose,
        disabled: loading
      }}
      rightButton={{
        text: translate("delete"),
        color: "error",
        onClick: onSubmit,
        loading: loading,
        disabled: !isValid
      }}
      isOpen={!!isOpenDeleteCoupons}
      setClose={handleClose}
      size="small"
    >
      <Stack justifyContent={"center"} alignItems={"center"} flex={1}>
        <Typography align="center">
          {translate("delete_coupon_text")}
        </Typography>
      </Stack>
    </DialogProvider>
  )
}
